import { ReactNode, useContext } from "react";
import useAnalytics from "../services/analytics/useAnalytics";
import UserContext from "./UserContext";
import Loading from "@/common/Loading";
import { useOptionalSelectedWorkspace } from "@/hooks/use-selected-workspace.ts";

export const IdentifiedUser = ({ children }: { children: ReactNode }) => {
    const analytics = useAnalytics();
    const userModel = useContext(UserContext);
    const workspace = useOptionalSelectedWorkspace();

    if (!userModel) {
        return <Loading />;
    }

    const organization = userModel.getCurrentOrganization();
    analytics.useIdentifiedUser(userModel, organization, workspace?.website);

    return children;
};
